<section class="w3l-hero-headers-11">
    <div class="hero-header-11">
        <div class="hero-header-11-content">
            <!-- banner -->
            <div id="homepage-slider" class="st-slider">
                <input type="radio" class="cs_anchor radio" name="slider" id="play1" checked="" />
                <input type="radio" class="cs_anchor radio" name="slider" id="slide1" />
                <input type="radio" class="cs_anchor radio" name="slider" id="slide2" />
                <input type="radio" class="cs_anchor radio" name="slider" id="slide3" />
                <div class="images">
                    <div class="images-inner">
                        <div class="image-slide">
                            <div class="banner-w3ls-1">
                                <div class="wrapper">
                                    <div class="slider-num d-grid grid-columns-auto">
                                        <h4>01<span>/03</span></h4>

                                    </div>
                                    <div class="d-grid grid-columns-auto-end">
                                        <div class="slider-text-w3ls">
                                            <span>Medical</span>
                                            <h4>We Care!</h4>
                                            <p>WE would be grateful if we could take a few moments to let us know your valuable opinion about your experience at cairo Cure  .</p>
                                            <a href="single.html" class="action"> Read More </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="image-slide">
                            <div class="banner-w3ls-2">
                                <div class="wrapper">
                                    <div class="slider-num d-grid grid-columns-auto">
                                        <h4>02<span>/03</span></h4>

                                    </div>
                                    <div class="d-grid grid-columns-auto-end">
                                        <div class="slider-text-w3ls">
                                            <span>Medical</span>
                                            <h4>Cairo Cure Oncology Center</h4>
                                            <p>Leading Private Oncology Facility in Egypt
                                              One of the Most Reputable in the Middle East Region
                                              Serving More Than 30,000 patients Worldwide.</p>
                                            <a href="single.html" class="action"> Read More </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="image-slide">
                            <div class="banner-w3ls-3">
                                <div class="wrapper">
                                    <div class="slider-num d-grid grid-columns-auto">
                                        <h4>03<span>/03</span></h4>

                                    </div>
                                    <div class="d-grid grid-columns-auto-end">
                                        <div class="slider-text-w3ls">
                                            <span>Medical</span>
                                            <h4>Cairo Cure oncology center</h4>
                                            <p>System to record the Patient databank, medical records , medical history and booking.</p>
                                            <a href="single.html" class="action"> Read More </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="labels">
                    <div class="fake-radio">
                        <label for="slide1" class="radio-btn"></label>
                        <label for="slide2" class="radio-btn"></label>
                        <label for="slide3" class="radio-btn"></label>
                    </div>
                </div>
            </div>
            <!-- //banner -->
        </div>
    </div>
</section>
<!-- call-to-action-17 -->

<section class="w3l-call-to-action-17_sur">
    <div class="call-to-action17_sur section-gap" >
      <div class="logo">
        <!-- <a class="brand-logo" href="index.html" style="color: rgb(10, 10, 158);">                                 Focus Software Solutions</a> -->

    </div>
      <div class="wrapper">
          <div class="action-top_sur">
            <div class="action17-top-left_sur">
              <img src="assets/images/background1.jpg" class="img" alt="" >

                    <img src="assets/images/emailturn.jpg" class="img" alt="" >
                </div>

                <div class="action17-top-right_sur">
                    <input id="tab1" type="radio" name="tabs" checked>
                    <label class="tabtle" for="tab1">MEDICAL SOLUTIONS</label>
                    <input id="tab2" type="radio" name="tabs">
                    <label class="tabtle" for="tab2">BUSINESS SOLUTIONS</label>
                    <input id="tab3" type="radio" name="tabs">
                    <label class="tabtle" for="tab3">MOBILE APP.</label>
                    <section id="content1" class="tab-content">
                        <div class="call-action_17">
                            <h3>Medical Centers Solutions</h3>
                            <p>Our company specializes in providing comprehensive healthcare technology solutions across a range of medical fields. We offer advanced Oncology Systems, Dental Systems, and Physical Therapy Systems, as well as tailored solutions for small medical centers. Our expertise extends to developing and managing Dental Clinic Centers, maintaining robust Oncology Medical Records with integrated statistics, and supporting Bone Clinic Centers with efficient and specialized systems.</p>
                            <a href="http://focus-its.net/" class="diff-btn btn">Read More</a>
                        </div>
                    </section>
                    <section id="content2" class="tab-content">
                        <div class="call-action_17">
                            <h3>Business Solutions</h3>
                            <p>our company delivers a wide range of enterprise and business management systems. We provide integrated ERP Systems, Point of Sale (POS) solutions, and Customer Relationship Management (CRM) tools to streamline operations across industries. Our systems support key business functions including Accounts Receivable, Accounts Payable, Stock Control, Sales, Purchasing, Treasury Management, Project Management, Payroll, General Ledger, and Human Resources.</p>
                            <a href="http://focus-its.net/" class="diff-btn btn">Read More</a>
                        </div>
                    </section>
                    <section id="content3" class="tab-content">
                        <div class="call-action_17">
                            <h3>WEB AND MOBILE APP.</h3>
                            <p>Design and Develop professional Static or
                              dynamic web Solutions as per the customer required including requirements analysis, development, and quality assurance. </p>
                            <a href="http://focus-its.net/" class="diff-btn btn">Read More</a>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- features-17 -->
<!-- <section class="w3l-features-17">
    <div class="features-17_sur section-gap" style="background-color: #0156a7;">
        <div class="wrapper">
            <div class="section-title text-center">
                <h4>Why Choose us</h4>
                <p class="sub-paragraph">Lorem, ipsum dolor sit amet consectetur adipisicing elit. Harum labore sed,
                    veniam nisi
                    sunt laboriosam ducimus, odio aspernatur fugiat minima blanditiis dignissimos.</p>
            </div>
            <div class="features-17-top_sur">
                <div class="features-17-left_sur">
                    <h2>Your health is our priority</h2>
                    <a href="#popup">Short video</a>


                    <div id="popup" class="pop-overlay">
                        <div class="popup">
                            <iframe src="https://www.youtube.com/embed/Z9-NFrckvHk" allowfullscreen></iframe>
                            <a class="close" href="#portfolio">&times;</a>
                        </div>
                    </div>

                </div>
                <div class="features-17-right_sur">
                    <div class="features-17-right-tp_sur">
                        <h5><a href="single.html">98% Success Rate</a></h5>
                        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Nulla, culpa id. Delectus doloremque
                            cupiditate asperiores.</p>
                    </div>
                    <div class="features-17-right-tp_sur">
                        <h5><a href="single.html">Professional Staff</a></h5>
                        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Nulla, culpa id. Delectus doloremque
                            cupiditate asperiores.</p>
                    </div>
                    <div class="features-17-right-tp_sur">
                        <h5><a href="single.html">Experienced Doctors</a></h5>
                        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Nulla, culpa id. Delectus doloremque
                            cupiditate asperiores.</p>
                    </div>
                    <div class="features-17-right-tp_sur">
                        <h5><a href="single.html">24/7 Emergency Care</a></h5>
                        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Nulla, culpa id. Delectus doloremque
                            cupiditate asperiores.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section> -->
<!-- /features-17 -->
<!-- features-4 -->
<!-- <section class="w3l-features-4">
    <div id="features4-block" class="section-gap">
        <div class="wrapper">
            <div class="section-title align-center text-center">
                <h4>Our Departments</h4>
                <p class="sub-paragraph">Lorem, ipsum dolor sit amet consectetur adipisicing elit. Harum labore sed,
                    veniam nisi sunt laboriosam ducimus, odio aspernatur fugiat minima blanditiis dignissimos.</p>
            </div>
            <div class="features4-grids text-center">
                <div class="features4-grid">
                    <div class="feature-icon">
                        <span class="fa fa-user-md" aria-hidden="true"></span>
                    </div>
                    <h5><a href="portfolio-single.html">Body Surgery</a></h5>
                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Aut quidem soluta quas vel. Harum esse
                        eligendi ducimus tempora placeat consectetur ab quasi tenetur aliquam. Quaerat cupiditate
                        consectetur.</p>
                    <a href="portfolio-single.html" class="gomore">Read More</a>
                </div>
                <div class="features4-grid">
                    <div class="feature-icon">
                        <span class="fa fa-heartbeat" aria-hidden="true"></span>
                    </div>
                    <h5><a href="portfolio-single.html">Dental Care</a></h5>
                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Aut quidem soluta quas vel. Harum esse
                        eligendi ducimus tempora placeat consectetur ab quasi tenetur aliquam. Quaerat cupiditate
                        consectetur.</p>
                    <a href="portfolio-single.html" class="gomore">Read More</a>
                </div>
                <div class="features4-grid">
                    <div class="feature-icon">
                        <span class="fa fa-plus-square" aria-hidden="true"></span>
                    </div>
                    <h5><a href="portfolio-single.html">Eye Care</a></h5>
                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Aut quidem soluta quas vel. Harum esse
                        eligendi ducimus tempora placeat consectetur ab quasi tenetur aliquam. Quaerat cupiditate
                        consectetur.</p>
                    <a href="portfolio-single.html" class="gomore">Read More</a>
                </div>
            </div>
        </div>
    </div>
</section> -->
<!-- features-4 -->
<!-- teams 27 block -->
<!-- <section class="w3l-teams-27">
    <div class="teams27 section-gap">
        <div class="wrapper">
            <div class="section-title text-center">
                <h4>Meet our team</h4>
                <p class="sub-paragraph">Lorem, ipsum dolor sit amet consectetur adipisicing elit. Harum labore sed,
                    veniam nisi sunt laboriosam ducimus, odio aspernatur fugiat minima blanditiis dignissimos.</p>
            </div>
            <div class="d-grid grid-col-2 main-contteam-28">
                <div class="team-main-19">
                    <div class="column-19">
                        <a href="team-single.html"><img class="image-fluid" src="assets/images/team1.jpg" alt=" "></a>
                    </div>
                    <div class="right-team-9">
                        <div class="teams-info">
                            <h6><a href="team-single.html" class="title-team-28">Mark Hyman</a></h6>
                            <p class="sm-text-28">Cosmetic Surgeon</p>
                            <p class="sub-paragraph midd-para-team">Lorem ipsum dolor sit amet, consectetur adipisicing
                                elit. Facilis omnis neque magnam illum ducimus blanditiis.</p>
                            <div class="buttons-teams">
                                <a href="#facebook" title="facebook"><span class="fa fa-facebook"
                                        aria-hidden="true"></span></a>
                                <a href="#instagram" title="instagram"><span class="fa fa-instagram"
                                        aria-hidden="true"></span></a>
                                <a href="#twitter" title="twitter"><span class="fa fa-twitter"
                                        aria-hidden="true"></span></a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="team-main-19">
                    <div class="column-19">
                        <a href="team-single.html"><img class="image-fluid" src="assets/images/team3.jpg" alt=" "></a>
                    </div>
                    <div class="right-team-9">
                        <div class="teams-info">
                            <h6><a href="team-single.html" class="title-team-28">Leana Wen</a></h6>
                            <p class="sm-text-28">Dental Surgeon</p>
                            <p class="sub-paragraph midd-para-team">Lorem ipsum dolor sit amet, consectetur adipisicing
                                elit. Facilis omnis neque magnam illum ducimus blanditiis.</p>
                            <div class="buttons-teams">
                                <a href="#facebook" title="facebook"><span class="fa fa-facebook"
                                        aria-hidden="true"></span></a>
                                <a href="#twitter" title="twitter"><span class="fa fa-twitter"
                                        aria-hidden="true"></span></a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="team-main-19">
                    <div class="column-19">
                        <a href="team-single.html"><img class="image-fluid" src="assets/images/team4.jpg" alt=" "></a>
                    </div>
                    <div class="right-team-9">
                        <div class="teams-info">
                            <h6><a href="team-single.html" class="title-team-28">Maria Santos</a></h6>
                            <p class="sm-text-28">Cardiologist</p>
                            <p class="sub-paragraph midd-para-team">Lorem ipsum dolor sit amet, consectetur adipisicing
                                elit. Facilis omnis neque magnam illum ducimus blanditiis.</p>
                            <div class="buttons-teams">
                                <a href="#facebook" title="facebook"><span class="fa fa-facebook"
                                        aria-hidden="true"></span></a>
                                <a href="#instagram" title="instagram"><span class="fa fa-instagram"
                                        aria-hidden="true"></span></a>
                                <a href="#twitter" title="twitter"><span class="fa fa-twitter"
                                        aria-hidden="true"></span></a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="team-main-19">
                    <div class="column-19">
                        <a href="team-single.html"><img class="image-fluid" src="assets/images/team2.jpg" alt=" "></a>
                    </div>
                    <div class="right-team-9">
                        <div class="teams-info">
                            <h6><a href="team-single.html" class="title-team-28">Paul P.Smith</a></h6>
                            <p class="sm-text-28">Neurology</p>
                            <p class="sub-paragraph midd-para-team">Lorem ipsum dolor sit amet, consectetur adipisicing
                                elit. Facilis omnis neque magnam illum ducimus blanditiis.</p>
                            <div class="buttons-teams">
                                <a href="#facebook" title="facebook"><span class="fa fa-facebook"
                                        aria-hidden="true"></span></a>
                                <a href="#twitter" title="twitter"><span class="fa fa-twitter"
                                        aria-hidden="true"></span></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</section> -->
<!-- //teams 27 block -->
<!-- customers4 block -->
<!-- <section class="w3l-customers-4">
    <div id="customers4-block" class="section-gap">
        <div class="wrapper">
            <div class="section-title align-center text-center">
                <h4>Testimonials</h4>
                <p class="sub-paragraph">Lorem, ipsum dolor sit amet consectetur adipisicing elit. Harum labore sed,
                    veniam nisi sunt laboriosam ducimus, odio aspernatur fugiat minima blanditiis dignissimos.</p>
            </div>
            <div id="mixedSlider">
                <div class="MS-content">
                    <div class="item">
                        <div class="imgTitle">
                            <img src="assets/images/patient1.jpg" alt="" />
                        </div>
                        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Similique, eius culpa dicta
                            asperiores odit, reiciendis commodi id a hic suscipit odio voluptatem ullam? Sit ut eos
                            quae! Quidem, nisi nesciunt.</p>
                        <h6>Abigail</h6>
                        <span>Lead Designer</span>
                    </div>
                    <div class="item">
                        <div class="imgTitle">
                            <img src="assets/images/patient2.jpg" alt="" />
                        </div>
                        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Similique, eius culpa dicta
                            asperiores odit, reiciendis commodi id a hic suscipit odio voluptatem ullam? Sit ut eos
                            quae! Quidem, nisi nesciunt.</p>
                        <h6>Charlotte</h6>
                        <span>Head of Support</span>
                    </div>
                    <div class="item">
                        <div class="imgTitle">
                            <img src="assets/images/patient3.jpg" alt="" />
                        </div>
                        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Similique, eius culpa dicta
                            asperiores odit, reiciendis commodi id a hic suscipit odio voluptatem ullam? Sit ut eos
                            quae! Quidem, nisi nesciunt.</p>
                        <h6>Benjamin Jin</h6>
                        <span>Founder, CEO</span>
                    </div>
                    <div class="item">
                        <div class="imgTitle">
                            <img src="assets/images/patient4.jpg" alt="" />
                        </div>
                        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Similique, eius culpa dicta
                            asperiores odit, reiciendis commodi id a hic suscipit odio voluptatem ullam? Sit ut eos
                            quae! Quidem, nisi nesciunt.</p>
                        <h6>Edward</h6>
                        <span>Team Leader</span>
                    </div>
                    <div class="item">
                        <div class="imgTitle">
                            <img src="assets/images/patient5.jpg" alt="" />
                        </div>
                        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Similique, eius culpa dicta
                            asperiores odit, reiciendis commodi id a hic suscipit odio voluptatem ullam? Sit ut eos
                            quae! Quidem, nisi nesciunt.</p>
                        <h6>Christoper</h6>
                        <span>Asst. Manager</span>
                    </div>

                </div>
                <div class="MS-controls">
                    <button class="MS-left"><i class="fa fa-angle-left" aria-hidden="true"></i></button>
                    <button class="MS-right"><i class="fa fa-angle-right" aria-hidden="true"></i></button>
                </div>
            </div>
        </div>
    </div>
</section> -->
<div class="w3l-grids-block-5">
    <!-- grids block 5 -->
    <section id="grids5-block" class="section-gap">
        <!-- <div class="wrapper">
            <div class="section-title align-center text-center">
                <h4>Recent News</h4>
                <p class="sub-paragraph">Lorem, ipsum dolor sit amet consectetur adipisicing elit. Harum labore sed,
                    veniam nisi sunt laboriosam ducimus, odio aspernatur fugiat minima blanditiis dignissimos.</p>
            </div>
            <div class="d-grid">
                <div class="grids5-info">
                    <a href="blog-single.html"><img src="assets/images/news1.jpg" alt="" /></a>
                    <h5>Medical</h5>
                    <ul class="info">
                        <li><span class="fa fa-calendar-o" aria-hidden="true"></span>3rd Oct 2019</li>
                        <li><span class="fa fa-user-o" aria-hidden="true"></span>Admin</li>
                    </ul>
                    <h4><a href="blog-single.html">News post title</a></h4>
                    <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Sint commodi cumque nulla deleniti
                        voluptas tempore optio quasi. Exercitationem doloremque nobis, pariatur amet libero optio quo...
                    </p>
                    <a href="blog-single.html" class="gomore">Read More</a>
                </div>
                <div class="grids5-info">
                    <a href="blog-single.html"><img src="assets/images/news2.jpg" alt="" /></a>
                    <h5>Medical</h5>
                    <ul class="info">
                        <li><span class="fa fa-calendar-o" aria-hidden="true"></span>3rd Oct 2019</li>
                        <li><span class="fa fa-user-o" aria-hidden="true"></span>Admin</li>
                    </ul>
                    <h4><a href="blog-single.html">News post title</a></h4>
                    <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Sint commodi cumque nulla deleniti
                        voluptas tempore optio quasi. Exercitationem doloremque nobis, pariatur amet libero optio quo...
                    </p>
                    <a href="blog-single.html" class="gomore">Read More</a>
                </div>
                <div class="grids5-info">
                    <a href="blog-single.html"><img src="assets/images/news3.jpg" alt="" /></a>
                    <h5>Medical</h5>
                    <ul class="info">
                        <li><span class="fa fa-calendar-o" aria-hidden="true"></span>3rd Oct 2019</li>
                        <li><span class="fa fa-user-o" aria-hidden="true"></span>Admin</li>
                    </ul>
                    <h4><a href="blog-single.html">News post title</a></h4>
                    <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Sint commodi cumque nulla deleniti
                        voluptas tempore optio quasi. Exercitationem doloremque nobis, pariatur amet libero optio quo...
                    </p>
                    <a href="blog-single.html" class="gomore">Read More</a>
                </div>
            </div>
        </div> -->
        <!-- // grids block 5 -->


        <!-- //form-25-section -->
